import React from 'react';
import { BOOST_ICON_IMAGE } from '../../../../utils/constants';
import { getComputedCSSVariable } from '../../../../utils/cssVariableHelpers';

const BoostedBadge: React.FC = () => {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      padding: '5px',
      backgroundColor: getComputedCSSVariable('lancaster-yellow'),
      borderRadius: '4px',
    }}
    >
      <img
        src={BOOST_ICON_IMAGE}
        alt="Boosted icon"
      />
      <span style={{
        fontSize: '12px',
        fontWeight: 'bold',
        color: getComputedCSSVariable('black'),
        marginLeft: '5px',
      }}
      >
        BOOSTED
      </span>
    </div>
  );
};

export default BoostedBadge;
